import {dropdownNodes} from './dropdownNodes';

const settings = {
  api: {
    url: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json',
    resultSelectorJSONata: '$.body.{\'name\': name, \'value\': code, \'image\': image, \'imageClass\': \'ui avatar image\'}',
  },
};

export const countryNodes = view => dropdownNodes({
  view, id: 'country', name: 'country', text: 'Country', settings,
});